module.exports = __webpack_public_path__ + "media/images/communities/logos/ao17-ff2a73f53ec874950f3699f0dd875f3e.png";